import React, { useEffect, useRef, useState } from 'react';

import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import logoIcon from '../../../assets/images/logo-icon.png';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Navbar = (props) => {
  const { t } = useTranslation();
  const [size, setSize] = useState(window.innerWidth);

  const typeAcc = useSelector((state) => state.profile.profile.authority);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setSize(window.innerWidth);
    };
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  const ref = useRef(null);
  const { onClickOutside } = props;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  const [isNavOpen, setNavOpen] = useState(false);

  return (
    <nav
      ref={ref}
      className={
        size <= 991
          ? !props.mob
            ? 'pcoded-navbar menupos-fixed menu-light brand-blue'
            : 'pcoded-navbar menupos-fixed menu-light brand-blue mob-open'
          : !isNavOpen
          ? 'pcoded-navbar menupos-fixed menu-light brand-blue navbar-collapsed'
          : 'pcoded-navbar menupos-fixed menu-light brand-blue'
      }
    >
      <div className="navbar-wrapper">
        <div className="navbar-brand header-logo">
          <Link to="/" className="b-brand">
            <img src={logo} alt="" className="logo images" />
            <img src={logoIcon} alt="" className="logo-thumb images" />
          </Link>
          <Link
            className={!isNavOpen ? 'mobile-menu' : 'mobile-menu on'}
            id="mobile-collapse"
            onClick={() => {
              setNavOpen(!isNavOpen);
            }}
            to="#!"
          >
            <span></span>
          </Link>
        </div>
        <div className="navbar-content scroll-div">
          <ul className="nav pcoded-inner-navbar">
            <li className="nav-item">
              <Link to="/" className="nav-link">
                <span className="pcoded-micon">
                  <i className="feather icon-home text-c-red"></i>
                </span>
                <span className="pcoded-mtext">{t('dashboard')}</span>
              </Link>
            </li>
            {typeAcc === 'TENANT_ADMIN' && (
              <li className="nav-item">
                <Link to="/customers" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="feather icon-users text-c-green"></i>
                  </span>
                  <span className="pcoded-mtext">{t('customer')}</span>
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link to="/map" className="nav-link">
                <span className="pcoded-micon">
                  <i className="feather icon-map text-c-blue"></i>
                </span>
                <span className="pcoded-mtext">{t('maps')}</span>
              </Link>
            </li>
            {typeAcc === 'TENANT_ADMIN' && (
              <li className="nav-item">
                <Link to="/document" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="feather icon-share-2 text-c-red"></i>
                  </span>
                  <span className="pcoded-mtext">{t('document')}</span>
                </Link>
              </li>
            )}
            {typeAcc === 'TENANT_ADMIN' && (
              <li className="nav-item">
                <Link to="/report" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="feather icon-download text-c-yellow"></i>
                  </span>
                  <span className="pcoded-mtext">{t('report')}</span>
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link to="/profile" className="nav-link">
                <span className="pcoded-micon">
                  <i className="feather icon-user text-c-brown"></i>
                </span>
                <span className="pcoded-mtext">{t('account')}</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
